import {post, upload, get} from './baseService';

export async function postUserGeneralInformation(data) {
    console.log(data, 'this is the data')
    return await post('general-Information', data, true).then(response=>response)
}
export async function postUserBiographicInformation(data) {
    return await post('biographic-Information', data, true).then(response=>response)
}
export async function postUserProfileImage(data) {
    return await upload('update-user-profile-image', data, 'post', true).then(response=>response)
}
export async function postUserAcademicInformation(data) {
    return await post('set-academic-information', data, true).then(response=>response)
}
export async function postUserProfessionalInformation(data) {
    return await upload('professional-information', data, 'post', true).then(response=>response)
}
export async function getUserBiographicInformation(userPublicId) {
    return await post('get-biographic-information', {'userPublicId':userPublicId}, true).then(response=>response)
}
export async function getUserAcademicInformation(userPublicId) {
    return await post('get-academic-information', {'userPublicId':userPublicId}, true).then(response=>response)
}
export async function getUserProfessionalInformation(userPublicId) {
    return await post('get-professional-information', {'userPublicId':userPublicId}, true).then(response=>response[0])
}
export async function postUserDocUpload(data) {
    return await upload('set-academic-information-upload-files', data, 'post', true).then(response=>response)
}
export async function postUserProDocUpload(data) {
    return await upload('set-professional-information-upload-files', data, 'post', true).then(response=>response)
}